module.exports = __webpack_public_path__ + "static/media/shenzhen.cba80849.svg";